// The submit rule for a composer draft, shared by the run composer and the
// chat home that creates a run from its first message.
import {
    draftIssue,
    MESSAGE_CHARACTER_LIMIT,
} from '@apps/web/features/phoebe_chat_v3/model/draft_rules';

export function canSubmitComposerValue(
    value: string,
    options: Readonly<{ readonly hasReadyAttachment?: boolean }> = {},
): boolean {
    return (
        draftIssue(value, {
            limit: MESSAGE_CHARACTER_LIMIT,
            required: options.hasReadyAttachment !== true,
        }) === null
    );
}
